import React from 'react';

import { Link } from '@reach/router';

import clubLogo from '../../../../assets/images/club-logo.svg';

interface IProps {
  imgSrc?: string | null;
  name: string;
  id?: string;
}

export const ListItem = (props: IProps) => {
  const { id, imgSrc, name } = props;

  return (
    <Link to={id ? `/staff/club/${id}` : '/home'} className="staff-home-list-item">
      <div className="club-icon">
        <img src={imgSrc || clubLogo} />
      </div>

      <span>{name}</span>
    </Link>
  );
};
